import { render, staticRenderFns } from "./SupervisionCourse.vue?vue&type=template&id=4bbf6483&scoped=true&"
import script from "./SupervisionCourse.vue?vue&type=script&lang=js&"
export * from "./SupervisionCourse.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionCourse.vue?vue&type=style&index=0&id=4bbf6483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf6483",
  null
  
)

export default component.exports